import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { ViewerGetDivisionEmployeesResponse, viewerApi } from 'app/services/edpApiV1/viewer';
import { RootState } from 'app/store';

const initialState: TDivisionEmployeesPayload = {
  employees: {
    data: [],
    pagination: { total: 0, size: 10, page: 1 },
  },
  error: null,
};

type TDivisionEmployeesPayload = {
  employees: ViewerGetDivisionEmployeesResponse;
  error: null | FetchBaseQueryError;
};

export type ViewerGetDivisionEmployeesRequest = {
  search: string;
  divisionId: string;
  page: number;
  size: number;
};

export const divisionEmployeesSlice = createSlice({
  name: 'divisionEmployees',
  initialState,
  reducers: {
    resetError(state) {
      return { ...state, error: null };
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      viewerApi.endpoints.getDivisionEmployees.matchFulfilled,
      (state: TDivisionEmployeesPayload, { payload }: PayloadAction<ViewerGetDivisionEmployeesResponse>) => {
        const { pagination, data } = payload;
        if (pagination.page > 1) {
          state.employees.data = [...state.employees.data, ...data];
          state.employees.pagination = pagination;
        } else {
          state.employees = payload;
        }
      },
    );
    builder.addMatcher(
      viewerApi.endpoints.getDivisionEmployees.matchRejected,
      (state, { payload }: PayloadAction<FetchBaseQueryError | undefined>) => {
        if (payload) {
          state.error = payload;
        }
      },
    );
  },
});
const employees = (state: RootState) => state.entities.viewer.divisionEmployees;
const getEmployees = createSelector(employees, state => state.employees.data);
const getEmployeesError = createSelector(employees, state => state.error);
export const selectors = { getEmployees, getEmployeesError };
export const actions = divisionEmployeesSlice.actions;
export const reducer = divisionEmployeesSlice.reducer;
